__turbopack_context__.v({
  "Content": "Review-module-scss-module__O-v1cG__Content",
  "Name": "Review-module-scss-module__O-v1cG__Name",
  "Rating": "Review-module-scss-module__O-v1cG__Rating",
  "Review": "Review-module-scss-module__O-v1cG__Review",
  "ReviewDetails": "Review-module-scss-module__O-v1cG__ReviewDetails",
  "ReviewImage": "Review-module-scss-module__O-v1cG__ReviewImage",
  "ReviewInfo": "Review-module-scss-module__O-v1cG__ReviewInfo",
  "ReviewQuote": "Review-module-scss-module__O-v1cG__ReviewQuote",
});
